import { createApp } from 'vue';
import AdminView from '../../admin/AdminView.vue'

const appElements = document.querySelectorAll('.vue-admin-view')

Array.from(appElements).forEach(element => {
  createApp(AdminView).mount(element);
});

